import React, { useState, useEffect } from 'react';
import { Row, Col, Select, Button, DatePicker, Progress } from 'antd';
// import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { APIs } from '../utils/apis';
import { get } from '../utils/httpRequests';
import { fetchActiveReportsMetaData } from '../actions/sessionActions';
import Loader from '../sharedComponent/Loader';

const { Option } = Select;

// nykaa, snitch, giva, decathlon, starquik-test, recode-westbengal
// const hldEnterprises = [13, 181345, 982576, 30403, 982334, 983410];

// const dimensions = ['landingPagePlusQueryString'];
const dimensions = [
  'eventName',
  //   'hostName',
  //   'customEvent:enterprise_id',
  'customEvent:qc_theme'
];
// For future use
// const metrics = [
//   'totalUsers',
//   'engagementRate',
//   'eventCount',
//   'eventCountPerUser',
//   'screenPageViewsPerSession',
//   'screenPageViewsPerUser',
//   'activeUsers',
//   'screenPageViews'
// ];

const metrics = [
  'eventCount',
  'eventValue',
  'screenPageViews',
  'sessions',
  'totalUsers'
];

const columns = [
  {
    title: 'Sessions',
    width: 33
  },
  {
    title: 'Screen Page Views',
    width: 33
  },
  {
    title: 'Total Users',
    width: 33
  }
];

const Analytics = ({ fetchActiveReportsMetaData, metadata }) => {
  const [state, setState] = useState({
    isLoading: false,
    enterpriseKey: null,
    enterpriseList: [],
    startDate: '',
    endDate: '',
    data: {
      rows: [],
      totals: []
    },
    qcData: {},
    dataFetched: false,
    dataError: false,
    isFetching: false,
    hldEnterprises: []
  });

  const handleChange = (fieldName, value) => {
    setState({ ...state, [fieldName]: value });
  };

  const fetchData = enterpriseKey => {
    setState({ ...state, dataFetched: false, isFetching: true });
    return get({
      url: `${APIs.ANALYTICS}enterprise_id=${enterpriseKey}&start_date=${moment(
        state.startDate
      ).format('DD-MM-YYYY')}&end_date=${moment(state.endDate).format(
        'DD-MM-YYYY'
      )}&dimension_names=${dimensions.join(',')}&metric_names=${metrics.join(
        ','
      )}`,
      method: 'GET'
    }).then(res => {
      if (res.status === 200 && res.data?.result) {
        state.data.rows = res.data.result?.rows ?? [];
        state.data.totals = res.data.result?.totals ?? {};
        state.qcData =
          res.data.result?.rows?.find(
            row => row?.['customEvent:qc_theme'] === 'true'
          ) ?? {};
        state.dataFetched = true;
        state.dataError = false;
        state.isFetching = false;
        setState({ ...state });
      } else {
        state.dataFetched = false;
        state.dataError = true;
        state.isFetching = false;
        setState({ ...state });
      }
    });
  };

  const getPercentage = (qcValue, totalValue) => {
    const percentage = ((qcValue / totalValue) * 100).toFixed(2);
    return !Number.isNaN(percentage) ? percentage : 0;
  };

  const fetchHLDEnterprises = () => {
    setState({ ...state, isFetching: true });
    get({
      url: `${APIs.FIREBASE['HLD-ENTERPRISES']}`,
      method: 'GET'
    }).then(res => {
      if (res.status === 200 && res.data?.result?.list) {
        const hldEnterprises =
          res.data.result.list.map(enterprise => enterprise.enterpriseId) || [];
        state.hldEnterprises = hldEnterprises;
        state.isFetching = false;
        setState({ ...state });
      } else {
        state.dataFetched = false;
        state.dataError = true;
        state.isFetching = false;
        setState({ ...state });
      }
    });
  };

  useEffect(() => {
    Promise.allSettled([
      fetchHLDEnterprises(),
      fetchActiveReportsMetaData('enterprise')
    ])
      .then(() => {
        state.isLoading = false;
        setState({ ...state });
      })
      .catch(() => {
        state.isLoading = false;
        setState({ ...state });
      });
  }, []);

  useEffect(() => {
    if (
      metadata.enterprise.list?.length > 0 &&
      state.hldEnterprises?.length > 0
    ) {
      const filteredEnterprises = metadata.enterprise.list.filter(enterprise =>
        state.hldEnterprises.includes(enterprise.id?.toString())
      );
      setState({
        ...state,
        enterpriseList: filteredEnterprises,
        isLoading: false
      });
    }
  }, [metadata.enterprise.list, state.hldEnterprises]);

  return (
    <div>
      <h2>HLD Analytics</h2>
      {state.isLoading ? (
        <Loader />
      ) : (
        <>
          <Row className="margin-bottom-10">
            <Col span={6}>
              <Select
                showSearch
                style={{ width: '96%' }}
                placeholder="Select enterprise"
                optionFilterProp="children"
                value={state.enterpriseKey ? state.enterpriseKey : undefined}
                onChange={value => handleChange('enterpriseKey', value)}
                allowClear={true}
              >
                {state.enterpriseList.map((enterprise, i) => (
                  <Option key={i} value={enterprise.id}>
                    {enterprise.name}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col span={6}>
              <div className="global-search-wrapper" style={{ width: '100%' }}>
                <DatePicker
                  defaultValue={
                    state.startDate ? moment(state.startDate) : null
                  }
                  style={{ width: '96%' }}
                  placeholder="Select Start Date"
                  name="startDate"
                  onChange={value => handleChange('startDate', value)}
                />
              </div>
            </Col>
            <Col span={6}>
              <div className="global-search-wrapper" style={{ width: '100%' }}>
                <DatePicker
                  defaultValue={state.endDate ? moment(state.endDate) : null}
                  style={{ width: '96%' }}
                  placeholder="Select End Date"
                  name="endDate"
                  onChange={value => handleChange('endDate', value)}
                />
              </div>
            </Col>
            <Col span={6}>
              <Button
                type="primary"
                onClick={() => fetchData(state.enterpriseKey)}
                disabled={
                  !state.enterpriseKey ||
                  !state.startDate ||
                  !state.endDate ||
                  state.isFetching
                }
                loading={state.isFetching}
              >
                {state.isFetching ? 'Fetching Data...' : 'Fetch Data'}
              </Button>
            </Col>
          </Row>
          {state.dataFetched ? (
            <>
              <Row className="margin-top-20">
                <Col span={12}>
                  <h3>QC Theme (HLD) Stats</h3>
                  <table
                    className={`ant-table ant-table-small width-100pt margin-top-20 text-left`}
                  >
                    <thead className="ant-table-thead">
                      <tr>
                        {columns.map((item, i) => (
                          <th
                            className="padding-8"
                            key={i}
                            width={`${item.width}%`}
                          >
                            {item.title}
                            {/* <Icon type="sort-ascending" /> */}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="ant-table-tbody">
                      <tr>
                        <td className="padding-8">
                          {state.qcData?.sessions || '---'}
                        </td>
                        <td className="padding-8">
                          {state.qcData?.screenPageViews || '---'}
                        </td>
                        <td className="padding-8">
                          {state.qcData?.totalUsers || '---'}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
                <Col span={12}>
                  <h3>All (HLD + Non HLD) Stats</h3>
                  <table
                    className={`ant-table ant-table-small width-100pt margin-top-20 text-left`}
                  >
                    <thead className="ant-table-thead">
                      <tr>
                        {columns.map((item, i) => (
                          <th
                            className="padding-8"
                            key={i}
                            width={`${item.width}%`}
                          >
                            {item.title}
                            {/* <Icon type="sort-ascending" /> */}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="ant-table-tbody">
                      <tr>
                        <td className="padding-8">
                          {state.data?.totals?.sessions || '---'}
                        </td>
                        <td className="padding-8">
                          {state.data?.totals?.screenPageViews || '---'}
                        </td>
                        <td className="padding-8">
                          {state.data?.totals?.totalUsers || '---'}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
              <Row className="margin-top-20">
                <Col span={6}>
                  <h3>Sessions - HLD/Total</h3>
                  <Progress
                    style={{ width: '90%' }}
                    percent={getPercentage(
                      state.qcData?.sessions,
                      state.data?.totals?.sessions
                    )}
                  />
                </Col>
                <Col span={2} />
                <Col span={6}>
                  <h3>Screen Page Views - HLD/Total</h3>
                  <Progress
                    style={{ width: '90%' }}
                    percent={getPercentage(
                      state.qcData?.screenPageViews,
                      state.data?.totals?.screenPageViews
                    )}
                  />
                </Col>
                <Col span={2} />
                <Col span={6}>
                  <h3>Total Users - HLD/Total</h3>
                  <Progress
                    style={{ width: '90%' }}
                    percent={getPercentage(
                      state.qcData?.totalUsers,
                      state.data?.totals?.totalUsers
                    )}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <div className="margin-top-20">
              {state.dataError
                ? 'Error fetching data'
                : 'Select filters and fetch data'}
            </div>
          )}
        </>
      )}
    </div>
  );
};

Analytics.propTypes = {
  metadata: PropTypes.object,
  config: PropTypes.object,
  fetchActiveReportsMetaData: PropTypes.func
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata
});

const mapDispatchToProps = dispatch => ({
  fetchActiveReportsMetaData: query =>
    dispatch(fetchActiveReportsMetaData(query))
});

export default connect(mapStateToProps, mapDispatchToProps)(Analytics);
